export const getHeadingElement = (level: number) => {
  switch (level) {
    case 1: {
      return 'h1'
    }
    case 2: {
      return 'h2'
    }
    case 3: {
      return 'h3'
    }
    case 4: {
      return 'h4'
    }
    default: {
      return 'h2'
    }
  }
}
